import { render, staticRenderFns } from "./20200730.vue?vue&type=template&id=536c6f43&lang=pug&"
var script = {}
import style0 from "./20200730.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536c6f43')) {
      api.createRecord('536c6f43', component.options)
    } else {
      api.reload('536c6f43', component.options)
    }
    module.hot.accept("./20200730.vue?vue&type=template&id=536c6f43&lang=pug&", function () {
      api.rerender('536c6f43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/20200730.vue"
export default component.exports